<loading [visible]="loading() || saving()"></loading>

@if (!loading()) {
<app-custom-modal [customTitle]="'Permisos: ' + roleName" (closeFunction)="closeFunction.emit()"
    (acceptFunction)="save()" maxWidth="4xl">

    <div class="overflow-x-auto">
        <table class="w-full text-sm">
            <thead>
                <tr class="border-b border-slate-200">
                    <th class="text-left py-2 pr-4 font-medium text-slate-600">Panel</th>
                    <th class="text-center px-3 font-medium text-slate-600">Leer</th>
                    <th class="text-center px-3 font-medium text-slate-600">Crear</th>
                    <th class="text-center px-3 font-medium text-slate-600">Editar</th>
                    <th class="text-center px-3 font-medium text-slate-600">Eliminar</th>
                </tr>
                <tr class="border-b border-slate-300 bg-slate-50">
                    <td class="py-1.5 pr-4 text-xs font-medium text-slate-400 italic">Todos</td>
                    <td class="text-center px-3">
                        <input type="checkbox"
                            [checked]="allRead"
                            [indeterminate]="someRead"
                            (change)="toggleAllRead($event)"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox"
                            [checked]="allCreate"
                            [indeterminate]="someCreate"
                            [disabled]="!hasAnyRead"
                            (change)="toggleAllCreate($event)"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox"
                            [checked]="allUpdate"
                            [indeterminate]="someUpdate"
                            [disabled]="!hasAnyRead"
                            (change)="toggleAllUpdate($event)"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox"
                            [checked]="allDelete"
                            [indeterminate]="someDelete"
                            [disabled]="!hasAnyRead"
                            (change)="toggleAllDelete($event)"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                </tr>
            </thead>
            <tbody>
                @for (row of rows; track row.panel_id) {
                <tr class="border-b border-slate-100 hover:bg-slate-50">
                    <td class="py-2.5 pr-4 font-medium text-slate-700">{{ row.label }}</td>
                    <td class="text-center px-3">
                        <input type="checkbox" [(ngModel)]="row.can_read" (change)="onReadChange(row)"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox" [(ngModel)]="row.can_create" [disabled]="!row.can_read"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox" [(ngModel)]="row.can_update" [disabled]="!row.can_read"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                    <td class="text-center px-3">
                        <input type="checkbox" [(ngModel)]="row.can_delete" [disabled]="!row.can_read"
                            class="w-4 h-4 rounded accent-slate-700 cursor-pointer disabled:opacity-30" />
                    </td>
                </tr>
                @if (row.name === 'documents' && row.can_read) {
                <tr class="border-b border-slate-100 bg-slate-50">
                    <td colspan="5" class="py-2.5 pl-6 pr-4">
                        <div class="flex flex-wrap items-center gap-x-4 gap-y-1.5">
                            <span class="text-xs font-medium text-slate-500 shrink-0">Tipos de documento:</span>
                            @for (type of documentTypes; track type.value) {
                            <label class="flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer select-none">
                                <input type="checkbox"
                                    [checked]="isDocTypeAllowed(row, type.value)"
                                    (change)="toggleDocType(row, type.value)"
                                    class="w-3.5 h-3.5 rounded accent-slate-600 cursor-pointer" />
                                {{ type.label }}
                            </label>
                            }
                            @if (row.allowed_document_types?.length) {
                            <span class="text-xs text-slate-400 italic ml-1">
                                ({{ row.allowed_document_types!.length }} de {{ documentTypes.length }})
                            </span>
                            } @else {
                            <span class="text-xs text-slate-400 italic ml-1">Todos los tipos</span>
                            }
                        </div>
                    </td>
                </tr>
                }
                }
            </tbody>
        </table>
    </div>

</app-custom-modal>
}